module.exports = __webpack_public_path__ + "media/bootstrap-icons/vinyl-f946ffa6.svg";